import script from "./Text.vue?vue&type=script&lang=ts&setup=true"
export * from "./Text.vue?vue&type=script&lang=ts&setup=true"

import "./Text.vue?vue&type=style&index=0&id=5533f724&lang=css"

const __exports__ = script;

export default __exports__